import axios from 'axios'
import CONFIG from '~config/env'

export const createNoAuthApiClientInstance = () => {
  if (NoAuthApiClient) return

  NoAuthApiClient = axios.create({
    baseURL: CONFIG.API.URL(),
    timeout: CONFIG.HTTP_TIMEOUT
  })
}

export let NoAuthApiClient
